<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('mbusked.title', 'Покинутий кошик') }}</h1>
          <div class="d-flex ">

            <div class="default-btn btn-white btn-green btn-with-icon btn-extrasmall mr-10" @click="createPost">
              <span class="text">{{ $static('mbusked.crt', 'Створити розсилку') }}</span>
              <span class="icons-holder">
                <span class="icon icon-nav-stack"></span>
              </span>
            </div>

            <div class="default-btn btn-white btn-green btn-with-icon btn-extrasmall" @click="loadAll">
              <span class="text">{{ $static('mbusked.lall', 'Завантажити повну інформацію') }}</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.28386 8.7561C2.28386 12.4092 4.93251 14.8976 7.90673 15.4127C8.24707 15.4716 8.47521 15.7952 8.41627 16.1357C8.35734 16.476 8.03367 16.7041 7.69332 16.6452C4.19932 16.0401 1.03302 13.0952 1.03302 8.7561C1.03302 6.91209 1.87196 5.46292 2.85168 4.3605C3.5535 3.5708 4.35642 2.9296 5.00216 2.4384H3.03847C2.7071 2.4384 2.43847 2.16977 2.43847 1.8384C2.43847 1.50704 2.7071 1.2384 3.03847 1.2384H6.63847C6.96984 1.2384 7.23847 1.50704 7.23847 1.8384V5.4384C7.23847 5.76977 6.96984 6.0384 6.63847 6.0384C6.30711 6.0384 6.03847 5.76977 6.03847 5.4384V3.22372L6.03666 3.22509C5.3509 3.7423 4.51272 4.37444 3.78666 5.19142C2.92924 6.15623 2.28386 7.32183 2.28386 8.7561ZM15.6131 9.24383C15.6131 5.62936 13.0206 3.1555 10.0846 2.60433C9.74513 2.5406 9.52159 2.21373 9.58533 1.87424C9.64906 1.53476 9.97593 1.31122 10.3154 1.37495C13.7645 2.02247 16.8639 4.95124 16.8639 9.24383C16.8639 11.0878 16.0249 12.537 15.0453 13.6394C14.3434 14.4291 13.5405 15.0703 12.8947 15.5616H14.8585C15.1899 15.5616 15.4585 15.8301 15.4585 16.1616C15.4585 16.4929 15.1899 16.7616 14.8585 16.7616H11.2585C10.9271 16.7616 10.6585 16.4929 10.6585 16.1616V12.5616C10.6585 12.2301 10.9271 11.9615 11.2585 11.9615C11.5898 11.9615 11.8585 12.2301 11.8585 12.5616V14.7762L11.8604 14.7747C12.5461 14.2575 13.3842 13.6255 14.1102 12.8085C14.9677 11.8437 15.6131 10.6781 15.6131 9.24383Z"
                  fill="#171717" />
              </svg>
            </div>
          </div>
        </div>

        <div class="row dashboard-row">
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon-2 icon-2bel"></span>
                <h4>{{ $static('mbusked.t1_1', 'Клієнти, яким ще не відправляли розсилку') }}</h4>
              </div>
              <div class="value">
                <span class="text">{{ pageInfo.pending }}</span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon icon-shopping-basket"></span>
                <h4>{{ $static('mbusked.t2', 'Товарів у кошику') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ pageInfo.items }}</span>
              </div>
            </div>
          </div>
          <div class="col-4 dashboard-col">
            <div class="dashboard-item ">
              <div class="title d-flex align-items-center">
                <span class="icon-2 icon-2wallet"></span>
                <h4>{{ $static('mbusked.t3', 'Сумма у кошику') }}</h4>
              </div>
              <div class="value">
                <span class="text"> {{ $filters.money(pageInfo.total) }} <small>{{ $store.getters.symbol
                    }}</small></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('users.title', 'Клієнтська база') }}</h1>
        </div>
        <div class="large-button-panel client-search-panel">
          <div class="search-panel w-100">
            <!--search panel-->
            <div class="search-group">
              <form @submit.prevent="getItems" autocomplete="off">
                <input type="text" name="input_search_multisend_busked" class="input-search form-control custom-input"
                  :placeholder="$static('users.search_1', 'Пошук за user ID/ Telegram username/ телефоном')"
                  v-model="filter.search">
                <button type="submit" class="search-btn">
                  <span class="icon icon-search"></span>
                </button>
              </form>
            </div>
            <!-- end search panel-->
          </div>
        </div>

        <div class="table-wrapper">
          <div class="table-responsive">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>User ID</th>
                  <th>{{ $static('users.w2', 'Ім\'я') }}</th>
                  <th>{{ $static('users.w3', 'Прізвище') }}</th>
                  <th>{{ $static('users.w4_1', 'Telegram username') }}</th>
                  <th>{{ $static('users.w5', 'Телефон') }}</th>
                  <th>{{ $static('users.w6', 'Електронна пошта') }}</th>
                  <th>{{ $static('mbusked.items', 'Товарів у кошику') }}</th>
                  <th>{{ $static('mbusked.total', 'Сумма товарів') }}, {{ $store.getters.symbol }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in items" :key="index">
                  <th scope="row">{{ user.id }}</th>
                  <td class="w-standart">
                    <div class="user-id-prev" v-if="user.telegram">
                      <!--                    <span class="avatar bg" :style="{'background-image': getAvatar(user)}"></span>-->
                      <span class="name">{{ user.telegram.id }}</span>
                    </div>
                  </td>
                  <td class="w-standart">{{ getInfo(user).first_name }}</td>
                  <td class="w-standart">{{ getInfo(user).last_name }}</td>
                  <td class="w-standart"><a v-if="user.username" :href="`https://t.me/${user.username}`">{{ "@" +
                    user.username }}</a></td>

                  <td class="w-standart"><a :href="'tel:' + getInfo(user).phone">{{ getInfo(user).phone }}</a></td>
                  <td class="w-standart">{{ getInfo(user).email }}</td>
                  <td class="w-standart">
                    <span v-if="user.info?.busked?.length">{{ user.info.busked.length }}</span>
                    <span v-else>0</span>
                  </td>
                  <td class="w-standart">
                    <span v-if="user.info?.busked?.length">
                      {{ $filters.money(getTotalBusked(user.info.busked)) }}
                    </span>
                    <span v-else>
                      0
                    </span>
                  </td>

                  <td>
                    <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
                      style="white-space: nowrap">
                      <button class="btn-icon btn-rounded btn-icon-transparent profile_edit" @click="openEditor(user)">
                        <span class="icon icon-edit"></span>
                      </button>
                    </Popper>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination-panel table-pagination" v-if="pages.length > 1">
          <nav>
            <router-link :to="{ name: 'MultisendBusked', params: { page: Math.max(pageIndex - 1, 1) } }"
              class="previous extreme" :class="{ 'disabled': pageIndex < 2 }">
              <span class="icons icon-left"></span>
            </router-link>
            <ul class="pagination pagination-list">
              <li v-for="(page, index) in pages" :key="index" :class="{ 'active': pageIndex === page }">
                <router-link :to="{ name: 'MultisendBusked', params: { page: page } }">{{ page }}</router-link>
              </li>
            </ul>
            <router-link :to="{ name: 'MultisendBusked', params: { page: Math.min(pageIndex + 1, pageAmount) } }"
              class="end extreme" :class="{ 'disabled': pageIndex > pageAmount - 1 }">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <!-- EDITOR WRAPPER-->
    <div class="overlay-editor client-profile-editor">
      <div class="overlay-editor-wrapper" v-if="selected">
        <div class="panel-top">
          <div class="panel-top-name">{{ $static('mbusked.edit', 'Кошик клієнта') }}</div>
          <a href="javascript:void(0);" class="back_trigger" @click="closeClienInfoEditor">
            <span class="icon icon-cross"></span>
          </a>
        </div>
        <div class="panel-middle">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label class="custom-label">{{ $static('users.uid', 'User ID:') }}</label>
                <div class="to-chat">
                  <div class="user-id-prev">
                    <span class="name">{{ selected.telegram_id }}</span>
                  </div>
                  <div class="button-holder">
                    <Popper arrow content="Coming Soon" hover placement="left" style="white-space: nowrap">
                      <button class="default-btn btn-with-icon btn-accent" disabled>
                        <span class="text">{{ $static('users.chat', 'Чат') }}</span>
                        <span class="icon icon-chat"></span>
                      </button>
                    </Popper>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="custom-label">{{ $static('users.t2_1', 'Telegram username:') }}</label>
                <input type="text" class="form-control custom-input"
                  :value="selected.username ? '@' + selected.username : ''" disabled="">
              </div>
            </div>
            <div class="col">
              <div class="option-line blacklist">
                <div class="option-name">{{ $static('users.block', 'Додати до чорного списку') }}</div>
                <div class="toggle-holder">
                  <div class="toggler r">
                    <input type="checkbox" class="toggle-check" v-model="info.ban">
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label class="custom-label">{{ $static('users.e1', 'Им\'я:') }}</label>
                <input type="text" class="form-control custom-input" v-model="selected.telegram.first_name" disabled>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="custom-label">{{ $static('users.e2', 'Прізвище:') }}</label>
                <input type="text" class="form-control custom-input" v-model="selected.telegram.last_name" disabled>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label class="custom-label">{{ $static('users.e4', 'Телефон:') }}</label>
                <input type="text" class="form-control custom-input" v-model="info.phone">
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="custom-label">{{ $static('users.e5', 'Email:') }}</label>
                <input type="text" class="form-control custom-input" v-model="info.email">
              </div>
            </div>
          </div>

          <div class="panel panel-bordered client-order-info row ">
            <div class="col client-order-info-col">
              <div class="d-flex justify-content-between align-items-center">
                <div class="custom-label">{{ $static('users.e6', 'Кількість замовлень:') }}</div>
                <div class="value">{{ selected.order_count }}</div>
              </div>
            </div>
            <div class="col client-order-info-col">
              <div class="d-flex justify-content-between align-items-center">
                <div class="custom-label">{{ $static('users.e7', 'Загальна сума замовлень,') }} {{ $store.getters.symbol
                  }}:</div>
                <div class="value">{{ selected.total }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label class="custom-label bold-label">{{ $static('users.e9', 'Замітки про клієнта:') }}</label>
              <textarea rows="15" class="form-control custom-input" v-model="info.comment"></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col mt-2">
              <label class="custom-label bold-label">{{ $static('mbusked', 'Товари у кошику') }}</label>
              <ul class="editor-order-list" v-if="selected?.info?.busked">
                <li class="order-list-item " v-for="(element, index) in selected.info.busked">
                  <div class="product-card-top d-flex justify-content-between">
                    <div class="product-card_main w-50">
                      <div class="product-card_img bg"
                        :style="{ 'background-image': $filters.backgroundImage(element.preview) }"></div>
                      <div class="product-card__title editor_trigger">{{ element.title }}</div>
                    </div>
                    <div class="option-item price-item">
                      <div class="name">{{ $static('order-e.t8', 'Ціна:') }}</div>
                      <div class="value" v-if="element.old_price"><strike>{{ $filters.money(element.old_price) }}
                          {{ $store.getters.symbol }}</strike> = {{ $filters.money(element.price) }} {{
                            $store.getters.symbol }}
                      </div>
                      <div class="value" v-else>{{ $filters.money(element.price) }}</div>
                    </div>
                    <div class="option-item" v-if="element.count">
                      <div class="name">{{ $static('order-e.t9', 'К-сть:') }}</div>
                      <div class="value">{{ element.count }}</div>
                    </div>
                    <div class="option-item" v-if="element.article">
                      <div class="name">{{ $static('order-e.art', 'Артикуль:') }}</div>
                      <div class="value">{{ element.article }}</div>
                    </div>
                  </div>
                  <div class="options-list">
                    <div class="option-list-title">{{ $static('order-e.t111', 'Параментри замовлення:') }}</div>
                    <div class="option-list-holder">
                      <div class="option-item " v-for="(op, opIndex) in element.add" :key="opIndex">
                        <div class="name">{{ op.option }}:</div>
                        <div class="value">{{ op.name }} {{ $filters.money(op.price) }}{{ $store.getters.symbol }}</div>
                      </div>
                      <div class="option-item " v-for="(op, opIndex) in element.u_select" :key="opIndex">
                        <div class="name">{{ op.name }}:</div>
                        <div class="value">{{ op.item.name }} {{ $filters.money(op.item.price) }}{{
                          $store.getters.symbol }}</div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <p v-else>Відсутні</p>
            </div>
          </div>
        </div>
        <div class="panel-bottom">
          <button class="transparent-btn default-btn back_trigger" @click="closeClienInfoEditor">
            <span class="text">{{ $static('users.cancel', 'Скасувати') }}</span>
          </button>
          <button class=" default-btn btn-accent" @click="save">
            <span class="text">{{ $static('users.save', 'Зберегти зміни') }}</span>
          </button>
        </div>
      </div>
    </div>
    <!--END EDITOR WRAPPER-->
  </Teleport>
</template>

<script>
import api from '@/api'

const pageSlotsAmount = 5;

export default {
  name: 'MultisendBusked',
  props: ['page'],
  data() {
    return {
      selected: undefined,
      filter: {
        page: 1,
        perPage: 10,
        search: undefined
      },
      client_filter: {
        page: 1,
        perPage: 5,
        user_id: undefined
      },
      sortBy: 'busked',
      items: [],
      client_items: [],
      total: 0,
      client_total: 0,
      pageInfo: {
        pending: 0,
        items: 0,
        total: 0
      },
      load: false,
      info: {}
    }
  },

  computed: {

    pageCount() {
      return Math.ceil(this.total / this.filter.perPage)
    },
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },
    pageAmount() {
      return Math.ceil(this.total / this.filter.perPage);
    },
    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
  },

  async mounted() {
    await this.getItems()
  },

  methods: {
    createPost() {
      let tomorow = new Date().getTime();
      tomorow = new Date(tomorow - tomorow % (86400 * 1000) + (86400 * 1000) + (36000 * 1000));

      this.$router.push(
        {
          name: 'PostEdit',
          params: {
            template: JSON.stringify(
              {
                info: {
                  segment: 'busked',
                  busked_update: 0,
                  callback: 'repeat',
                  delay: 1
                },
                timestamp: tomorow.getTime()
              })
          }
        })
    },

    openEditor(item, event) {
      window.$('.back-blur').off('click'); // удаляем слушатель события клика на бэк-блюр поставленный в AdminBox. Он визуально скрывает модальное окно слишком рано - до момента сохранения данных и или их обновления.
      window.$('.back-blur').on('click', () => this.closeClienInfoEditor());

      this.selected = { ...item };
      if (this?.selected?.info) {
        this.info = { ...this.selected.info };
      }

      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');
      window.$('.back-blur').addClass('active');
      window.$('.client-profile-editor').addClass('active');
    },

    async closeClienInfoEditor() {
      window.$('.client-profile-editor').remove('active');
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');

      this.selected = undefined;
      this.info = {};

      //Возвращаем взад удаленного в SettingsModalBox слушателя, который нам мешал, но используется в функционале нашего ресурса.
      window.$('.back-blur').off('click');

      window.$('.back-blur').on('click', function () {
        window.$('body > .active').removeClass('active');
        window.$('body').removeClass('is-hidden');
      });
    },

    getInfo(item) {
      return { ...item.info, ...item.telegram };
    },
    getTotalBusked(busked) {
      return busked.reduce((prev, next) => prev + next.price, 0)
    },

    async getItems() {
      try {
        const response = await api.post('/api/client/filter', { filter: this.filter, sortBy: this.sortBy });
        const data = response.data;

        this.items = data.result.map(i => {
          i.created_at = new Date(i.created_at);
          i.updated_at = new Date(i.updated_at);
          return i;
        });

        this.filter.page = data.page;
        this.total = data.total;

        this.pageInfo.pending = 0;
        this.pageInfo.items = 0;
        this.pageInfo.total = 0;

        if (this.items.length) {
          this.items.forEach(i => {
            if (i.info?.busked_update) {
              this.pageInfo.pending++;
              if (i.info?.busked?.length) {
                this.pageInfo.items += i.info.busked.length;
                this.pageInfo.total += this.getTotalBusked(i.info.busked);
              }
            }

          });
        }
      } catch (error) {
        console.error("Ошибка загрузки элементов:", error);
      }
    },

    async save() {
      if (this.load) {
        return
      }

      this.load = true;
      try {
        let obj = { ...this.selected, info: this.info };

        const response = await api.put('/api/client', obj);
        const item = response.data;

        item.created_at = new Date(item.created_at);
        item.updated_at = new Date(item.updated_at);

        const idx = this.items.findIndex(i => i.id === item.id);
        this.items[idx] = item;

        this.$notify({
          title: this.$static('notify.client-title', 'Клієнт'),
          text: this.$static('notify.save', 'Збережено.'),
          duration: 3000
        });

        await this.getItems();
        this.closeClienInfoEditor();
      } catch (error) {

        console.error('Error saving settings:', error);

        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('notify.error', 'Помилка при збереженні данних.'),
          type: 'error',
          duration: 3000
        });

      } finally {
        this.load = false;
      }
    },

    async loadAll() {
      try {
        const response = await api.get('/api/client/info');
        const data = response.data;

        if (data) {
          this.pageInfo = data;
        }
      } catch (error) {
        console.error("Ошибка загрузки данных:", error);
      }
    }
  },

  watch: {
    async page(val) {
      this.filter.page = val;
      await this.getItems()
    },
  }
}
</script>
